import { render } from "./Reports.vue?vue&type=template&id=210aff2a&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=210aff2a&scoped=true&lang=css"
import "./Reports.vue?vue&type=style&index=1&id=210aff2a&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210aff2a"]])

export default __exports__